import './styles.scss';

interface IIConLInk {
  href: string;
  icon?: string;
}

export default function IconLink({href, icon = 'bi bi-alarm'}: IIConLInk){
  return (
    <a href={href} rel="noreferrer" target="_blank" className="icon-link is-large">
        <i className={icon}></i>
    </a>
  )
}